import { createContext } from 'react';

import { RouteConfig } from 'core/dna/types/local';

export const ModuleRoutesContext = createContext<RouteConfig[]>([]);

ModuleRoutesContext.displayName = 'Module Routes Context';
